export default __webpack_public_path__ + "static/media/wallet-icon-home-mobile.5269abb3.webp";